import { render, staticRenderFns } from "./TextWithChevron.vue?vue&type=template&id=ba3f4bd2&"
import script from "./TextWithChevron.vue?vue&type=script&lang=ts&"
export * from "./TextWithChevron.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports